<template>
  <div id="app" :class="['app-' + processedString]" @scroll="handleScroll" ref="scrollContainer">
    <m-nav-bar v-if="isMobile"></m-nav-bar>
    <nav-bar :bg-opacity="transparentNav" v-else></nav-bar>
    <router-view />
    <m-footer-nav v-if="isMobile"></m-footer-nav>
    <footer-nav v-else></footer-nav>
    <div class="back-to-top" v-if="isMobile && showScrollToTop" @click="scrollToTop">
      <i class="iconfont icon-gotop"></i>
    </div>
  </div>
</template>
<script>
import {
  ajaxGet
} from '@/utils/ajax.js';
import {
  EventBus
} from "@/utils/event-bus.js";
import navbar from "@/components/navbar.vue"
import footerNav from "@/components/footerNav.vue"

import mNavbar from "@/components/m/navbar.vue"
import mFooterNav from "@/components/m/footerNav.vue"
export default {
  components: {
    "nav-bar": navbar,
    "footer-nav": footerNav,
    "m-nav-bar": mNavbar,
    "m-footer-nav": mFooterNav,
  },
  data() {
    return {
      isMobile: false,
      showScrollToTop: false,
      activeTab: "/",
      caseBannerVisible: false,
      transparentNav: 1, // 导航栏透明度
    };
  },
  created() {
    this.isMobile = /Mobi|Android/i.test(navigator.userAgent)
    this.activeTab = this.$route.path;
    EventBus.$on("setCaseBannerVisible", this.setCaseBannerVisible);
    ajaxGet('/type_list').then(res => {
      sessionStorage.setItem('caseType', JSON.stringify({
        page: "/",
        sId: 4,
        cId: 0
      }));
      this.$store.dispatch('setCaseList', res.data.typeData);
    })
  },
  mounted() {
    this.setRootFontSize();
    window.addEventListener('resize', this.setRootFontSize);
    window.addEventListener('scroll', this.handleScroll);
    this.updateTransparentNav();
  },
  beforeDestroy() {
    // 移除事件监听，避免内存泄漏
    window.removeEventListener('resize', this.setRootFontSize);
    window.removeEventListener('scroll', this.handleScroll);
    EventBus.$off("setCaseBannerVisible", this.setCaseBannerVisible);
  },
  computed: {
    processedString() {
      const strWithoutSlashes = this.activeTab.replace(/\//g, '');
      return strWithoutSlashes === '' ? 'index' : strWithoutSlashes;
    }
  },
  watch: {
    '$route'(to) {
      this.activeTab = to.path;
      this.updateTransparentNav();
    },
  },
  methods: {
    setRootFontSize() {
      const fontSize = Math.max(10, window.innerWidth / 100) + 'px';
      document.documentElement.style.fontSize = fontSize;
    },
    handleScroll() {
      if (this.isMobile) {
        const scrollTop = this.$refs.scrollContainer.scrollTop;
        this.showScrollToTop = scrollTop > 300;
      } else {
        this.updateTransparentNav();
      }
    },
    setCaseBannerVisible(visible) {
      this.caseBannerVisible = visible;
      this.updateTransparentNav();
    },
    hasTransparentNav() {
      return this.activeTab == "/" || this.activeTab == "/index" || (this.activeTab == "/case" && this.caseBannerVisible);
    },
    updateTransparentNav() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (this.hasTransparentNav() && scrollTop <= 300) {
        this.transparentNav = 0;
      } else {
        this.transparentNav = 1;
      }
    },
    scrollToTop() {
      this.$refs.scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
  }
}
</script>
<style lang="scss">
@import "./assets/css/main.css";

#app {
  width: 100%;
  height: 100%;
  // overflow-x: hidden;
  padding-top: 5.525rem;
  // overflow-y: auto;

  .back-to-top {
    background-color: rgba(0, 0, 0, 0.5);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    border-radius: 50%;
    position: fixed;
    right: 20px;
    bottom: 72px;
    box-shadow: 0px 0px 8px 1px #FFF;

    .icon-gotop {
      font-size: 20px;
    }
  }
}

.app-index {
  padding-top: 0 !important;
}

.no-data {
  padding: 2rem 0;
  text-align: center;
  font-size: 1.2rem;
  color: #999;
}

// 轮播样式
.swiper {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  .swiper-wrapper {
    height: 100%;

    .swiper-slide {
      height: 100%;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    &::after {
      color: #9fa0a0;
      font-size: 3.5rem;
    }

    span.iconfont {
      font-size: 3.5rem;
      color: #9fa0a0;
    }

    span.iconfont:hover {
      color: #FF6600;
    }
  }

  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    &::after {
      color: #FF6600;
    }
  }

  .swiper-pagination .swiper-pagination-bullet-active {
    background: #FF6600;
  }
}

// 分页样式
.el-pagination {
  text-align: center;
  margin-top: 2.25rem;

  button,
  .el-pager li {
    width: 2rem;
    height: 2rem !important;
    line-height: 2rem !important;
    margin: 0 0.325rem;
    font-size: 0.925rem;
  }

  &.is-background .btn-next,
  &.is-background .btn-prev,
  &.is-background .el-pager li {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 1px solid #C4C5C6 !important;
    font-weight: 100;
    font-family: 'cf-思源黑体';
  }

  &.is-background .el-pager li:not(.disabled):hover {
    color: #FF6600 !important;
  }

  &.is-background .el-pager li:not(.disabled).active {
    background-color: rgba(255, 102, 0, 1) !important;
    color: #FFF !important;
    border-color: #FF6600 !important;
  }
}
</style>
